import React from "react"
import MobileMenu from "../MobileMenu"
import logo from "../../../assets/images/crm-logo.png"
import classes from "./MobilePanel.module.scss"

interface IMobilePanelProps {
  className?: string
}

function MobilePanel({className}: IMobilePanelProps) {

  const cls = [classes.wrap]

  if (className) {
    cls.push(className)
  }

  return (
    <div className={cls.join(" ")}>
      <div className={classes.logo}>
        <img src={logo} alt=""/>
      </div>
      <MobileMenu/>
    </div>
  )
}

export default MobilePanel